import { render } from "./ZinsPreview.vue?vue&type=template&id=af954840"
import script from "./ZinsPreview.vue?vue&type=script&lang=js"
export * from "./ZinsPreview.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/Vakifbank-Vue-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__